

export class userAddress {
    city: string;
    state: string;
}

export class uniqueFieldValidation {
    emailId: string;
    gstNumber: string;
    panNumber: string;
    mobileNumber: string
    userName: string;
    programName: string
    isUserUpdate: boolean
    updateUserName: string;
    additionalMobileNumber: string;
    creationMode: string;

    uniqueFieldValidation() {
        this.emailId = '';
        this.gstNumber = '';
        this.panNumber = '';
        this.mobileNumber = '';
        this.programName = '';
        this.isUserUpdate = false;
        this.updateUserName = '';
        this.additionalMobileNumber = '';
        this.creationMode = '';
    }
}